module.exports = __webpack_public_path__ + "img/videoPoster.cd90c4c0.png";